import { defineComponent as _defineComponent } from 'vue'
import TableHeader, { TableHeaderProps } from '@/components/molecules/table/header/TableHeader.vue';
import TableRow, { TableRowProps } from '@/components/molecules/table/row/TableRow.vue';
import Loading from '@/components/atoms/loading/Loading.vue';

export interface TableContainerProps {
    header: TableHeaderProps;
    body: TableRowProps[];
    isLoading?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableContainer',
  props: {
    header: null,
    body: null,
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true,TableHeader, TableRow, Loading }
}

})